import { axiosGet } from '../../axios/axios.js'
import FilesGroupsContainer from '../File/FilesGroupsContainer.js'
import FilesGroup from '../File/FilesGroup.js'
import { getHasValueValidateFn } from './bussinessProcessObjectValidation.js'

// extended by VehicleProvisionDispatcher.vue, VehicleProvisionMobile.vue, StockInventoryTask.vue

export const bussinessProcessObjectInitialization = {
  created: function () {
    if (!(this.bussinessProcessConfiguration != null &&
      this.bussinessProcessConfiguration.REQUEST_PROPERTIES != null &&
      this.bussinessProcessConfiguration.EVENTS_PROPERTIES != null &&
      this.bussinessProcessConfiguration.businessProcessKey != null &&
      this.bussinessProcessConfiguration.serviceSubPath != null)) {
      throw new Error('Необходимо задать объект конфигурации')
    }
  },
  methods: {
    setRequestProperties: function (record) {
      const requestProperties = {}

      Object.keys(this.bussinessProcessConfiguration.REQUEST_PROPERTIES).forEach(propertyKey => {
        const requestPropertiesGetter = this.bussinessProcessConfiguration.REQUEST_PROPERTIES[propertyKey]
        const propertyConfig = requestPropertiesGetter && requestPropertiesGetter()
        if (!propertyConfig) {
          return
        }
        const label = propertyConfig.label || propertyKey

        requestProperties[propertyKey] = {
          key: propertyKey,
          label: label,
          type: propertyConfig.type || null,
          subType: propertyConfig.subType || null,
          recordProperties: propertyConfig.recordProperties || null,
          readonly: true,
          hidden: false,
          blank: propertyConfig.blank || false,
          accessProps: null,

          requiredFn: null, // заполняется при нажатии кнопки из customRequiredFn || serverRequiredFn
          customRequiredFn: propertyConfig.customRequiredFn || null,
          serverRequiredFn: null, // заполняется при нажатии кнопки из поля required

          validateFn: getHasValueValidateFn(propertyConfig.type, propertyConfig.subType), // наличие значения в поле (зависимо от requiredFn (required в action))
          dateTimeValidateFn: null, // / заполняется при нажатии кнопки. проверки на сравнение с текущим временем (зависимо от moreOrEqualCurrent в action)
          dateTimeValidateMessage: getDateTimeValidateMessage(label),
          additionalValidateFn: propertyConfig.additionalValidateFn || null, // дополнительные проверки (независимо от action)
          getAdditionalValidateMessage: propertyConfig.getAdditionalValidateMessage || null,

          convertItemToServer: propertyConfig.convertItemToServer || null, // Только для массива! Преобразование записи из массива

          request: record.request,
          requestProperties: requestProperties
        }
      })
      record.requestProperties = requestProperties

      this.updateValidationConfiguration(record)
      this.updateFormConfiguration(record)
    },
    updateValidationConfiguration (record) {
      const actions = record.actions
      const requestProperties = record.requestProperties

      const saveBtn = actions.find(btn => btn.id === 'save' || btn.id === 'create')
      if (saveBtn) {
        saveBtn.requestValidation.forEach(requestValidationField => {
          const requestProperty = requestProperties[requestValidationField.property]
          if (requestProperty) {
            requestProperty.readonly = requestValidationField.readonly
            requestProperty.accessProps = requestValidationField
          }
        })
      }
    },
    updateFormConfiguration (record) {
      const requestForm = record.requestForm
      const requestProperties = record.requestProperties

      if (requestForm && requestForm.properties) {
        requestForm.properties.forEach(requestFormProperty => {
          if (requestFormProperty.hidden) {
            requestProperties[requestFormProperty.name].hidden = true
          }
        })
      }
    },
    load: function (id = this.record.request.id, additionalParams = null) {
      this.loading = true

      return this.getRecord(id, additionalParams)
        .then(result => {
          const record = result
          let requestInitial = null

          if (record.requestEmpty) {
            requestInitial = JSON.parse(JSON.stringify(record.requestEmpty))

            // Чтобы отправились табличные поля на сервер из шаблона при создании
            Object.keys(record.request).forEach(key => {
              const requestPropertiesGetter = this.bussinessProcessConfiguration.REQUEST_PROPERTIES[key]
              const propertyConfig = requestPropertiesGetter && requestPropertiesGetter()
              if (propertyConfig && propertyConfig.type === 'table') {
                record.request[key].forEach(tableValue => {
                  if (!record.requestEmpty[key].find(val => val.id && tableValue.id && val.id === tableValue.id || val.key && tableValue.key && val.key === tableValue.key)) {
                    tableValue.added = true
                  }
                })
              }
            })
          } else {
            requestInitial = JSON.parse(JSON.stringify(record.request))
          }
          record.requestInitial = requestInitial

          // for (const action of record.actions) {
          //   action.requestValidation.forEach(requestValidationField => {
          //     if (requestValidationField.readonly && requestValidationField.required) {
          //       requestValidationField.required = false
          //     }
          //   })
          // }

          // Файлы ---
          const documents = record.request.documents || []

          const filesGroupSourceConfig = {
            objectId: record.request.id || null, // -1,
            uploadURL: '/service/delta/document/upload',
            removeURL: '/service/delta/document/deleteFromObject',
            removeDelayed: true,
            removeRelationships: true
          }

          const key = 'readyDocument'
          const filesGroup = new FilesGroup({
            categoryKey: key,
            readonly: false, // TODO
            sourceConfig: filesGroupSourceConfig,
            documents: documents.filter(document => document.category === key)
          })

          const filesGroupsContainer = new FilesGroupsContainer()
          filesGroupsContainer.addFilesGroup(filesGroup)
          record.request._filesGroups = filesGroupsContainer

          // ---

          record.id = record.bp.id || -1
          if (!record.request.id) {
            record.request.id = -1
          }
          record.requestProperties = null

          this.prepareActions(record.actions, record)

          record.bp.events = record.bp.events || []
          for (const event of record.bp.events) {
            if (!event.eventService) {
              event.eventService = this.bussinessProcessConfiguration.serviceSubPath
            }
            this.prepareForm(event.form, record)
          }

          Object.defineProperty(record, 'prepareAction', {
            value: (action) => this.prepareAction(action, record),
            writable: true,
            enumerable: false,
            configurable: true
          })

          Object.defineProperty(record, 'processCustomAction', {
            value: this.processCustomAction || null,
            writable: true,
            enumerable: false,
            configurable: true
          })

          this.setRequestProperties(record)
          this.record = record
          return record
        })
        .finally(() => {
          this.loading = false
        })
    },
    getRecord: function (id, additionalParams = null) {
      const params = new URLSearchParams()
      params.set('id', id)
      if (additionalParams) {
        Object.keys(additionalParams).forEach(key => {
          params.set(key, JSON.stringify(additionalParams[key]))
        })
      }
      return axiosGet({
        url: `/service/delta/${this.bussinessProcessConfiguration.serviceSubPath}/get?` + params.toString(),
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка загрузки заявки'
      })
    },
    onUpdateByChanges: function (changes) {
      const id = this.record.request.id
      if (id == null) {
        // TODO обрабатывать и этот случай на сервере
        return
      }
      const additionalParams = {
        properties: changes
      }

      this.loading = true
      this.getRecordUpdate(id, additionalParams)
        .then(result => {
          this.prepareActions(result.actions, this.record)
          const record = result
          this.record.actions = record.actions
          this.record.requestForm = record.requestForm
          this.record.request.name = result.request.name
          this.updateValidationConfiguration(this.record)
          this.updateFormConfiguration(this.record)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getRecordUpdate: function (id, additionalParams = null) {
      const params = new URLSearchParams()
      params.set('id', id)
      if (additionalParams) {
        Object.keys(additionalParams).forEach(key => {
          params.set(key, JSON.stringify(additionalParams[key]))
        })
      }
      return axiosGet({
        url: `/service/delta/${this.bussinessProcessConfiguration.serviceSubPath}/update?` + params.toString(),
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка загрузки обновленных параметров заявки'
      })
    },
    prepareActions: function (actions, record) {
      for (const action of actions) {
        this.prepareAction(action, record)
      }
    },
    prepareAction: function (action, record) {
      if (!action.businessProcessKey) {
        action.businessProcessKey = this.bussinessProcessConfiguration.businessProcessKey
      }

      if (action.forms && action.forms.length) {
        for (const form of action.forms) {
          this.prepareForm(form, record)
        }
      }
    },
    prepareForm: function (form, record) {
      if (form && form.contentType && form.contentType !== 'empty') {
        const eventPropertiesGetter = this.bussinessProcessConfiguration.EVENTS_PROPERTIES[form.contentType] || null
        if (eventPropertiesGetter) {
          form.eventProperties = eventPropertiesGetter()
          Object.keys(form.eventProperties).forEach(propKey => {
            const property = form.eventProperties[propKey]

            Object.defineProperty(property, '_record', {
              value: record,
              writable: true,
              enumerable: false,
              configurable: true
            })

            property.componentProps = property.componentProps || {}
            property.componentProps._record = record
            if (property.componentProps.proxy) {
              property.componentProps.proxy._record = record
            }
          })
        }
      }
    }
  }
}

function getDateTimeValidateMessage (label) {
  return `«${label}» не может быть меньше текущего времени`
}
